/*
 * @Author: your name
 * @Date: 2020-11-23 10:05:07
 * @LastEditTime: 2021-06-21 15:40:11
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\assets\scripts\handleDataAndSign.js
 */
/*
** uri {String 接口}
** formData {Object 需要传入的参数}
** yeming 2019/3/8
*/

import { setObjToString } from "./setObjToString";
import { shallowClone } from "./clone";
import ORIGINALPARAM from "./originalParam";
import NEWSALT from "./newSalt";
import $md5 from 'js-md5';
import Vue from 'vue'

export function handleDataAndSign(url, formData, sn = '') {
  let paramsDataStr = "";
  let handleData = {};
  for (let key in formData) {
    (formData[key] === undefined) && delete formData[key]
  }
  let originDataClone = shallowClone(ORIGINALPARAM);
  originDataClone.t = new Date().getTime();
  handleData = Object.assign(originDataClone, formData);
  if (Vue.$cookies.get("token")) {
    handleData.token =  Vue.$cookies.get("token");
  }
  paramsDataStr = setObjToString(handleData);
  handleData.s = $md5(sn + url + paramsDataStr + NEWSALT);
  return handleData;
}
